import React, { useState, useEffect, useRef, Fragment } from 'react'
import { connect } from 'react-redux'
import Styles from './AddStationModal.module.css'
import { Colors } from 'Theme'
import { useTranslation } from 'react-i18next'
import StationActions from 'Stores/Station/Actions'
import StationSelectors from 'Stores/Station/Selectors'
import RequestState from 'Enums/RequestState'
import {
  IFMap,
  IFModal,
  IFText,
  IFTextInput,
  IFTooltipIconsLoading,
  IFsvg,
  IFToggle,
} from 'Components'

import PropTypes from 'prop-types'
import validator from 'validator'
import AuthSelectors from 'Stores/Auth/Selectors'
import Icon from '@mui/material/Icon'
import AddIcon from '@mui/icons-material/Add'
import AddCityModal from 'Containers/AddCityModal/AddCityModal'
import FormControl from '@mui/material/FormControl'
import { SelectPicker } from 'rsuite'
import { styled as muiStyled } from '@mui/system'
import { v4 as uuidv4 } from 'uuid'
const ct = require('countries-and-timezones')

const AddStationModal = React.forwardRef(
  (
    {
      operatorUser,
      addStationRequestState,
      addStation,
      cities,
      stationsFilter,
      addCityRequestState,
      operator,
    },
    ref,
  ) => {
    const initialCoordinates = '30.04440,31.23570'
    const [stationName, setStationName] = useState('')
    const [streetName, setStreetName] = useState('')
    const [city, setCity] = useState('')
    const [coordinates, setCoordinates] = useState(initialCoordinates)
    const [citiesOptions, setCitiesOptions] = useState([])
    const [isPrivateAccess, setIsPrivateAccess] = useState(false)
    const addCityModalRef = useRef()
    const isPrivateAccessRef = useRef()
    const [stationNameError, setStationNameError] = useState('')
    const [streetNameError, setStreetNameError] = useState('')
    const [cityError, setCityError] = useState('')
    const [coordinatesError, setCoordinatesError] = useState('')

    const { t } = useTranslation()
    const StyledFormControl = muiStyled(FormControl)({
      boxShadow: `0px 0px 4px ${Colors.black} `,
      borderRadius: '5px',
      marginTop: '1px',
    })

    useEffect(() => {
      let citiesOptionsNew = []
      for (const index in cities) {
        citiesOptionsNew.push({
          label: (
            <IFText style={{ color: Colors.text }}>{cities[index]}</IFText>
          ),
          value: cities[index],
        })
      }
      setCitiesOptions(citiesOptionsNew)
    }, [stationsFilter])

    useEffect(() => {
      if (addCityRequestState === RequestState.SUCCEEDED) {
        setCity(addCityModalRef.current.returnLastAddedCity())
      }
    }, [addCityRequestState])

    useEffect(() => {
      if (addStationRequestState === RequestState.SUCCEEDED) {
        ref.current.dismiss()
        handleClose()
      }
    }, [addStationRequestState])

    const addNewStation = () => {
      const country = ct.getCountry(operator.country?.codeTwoLetters)
      let timeZone = country?.timezones ? country.timezones[0] : 'Africa/Cairo'
      const station = {
        uuid: uuidv4(),
        name: stationName,
        location: {
          streetName: streetName,
          city: city,
          latitude: coordinates.replaceAll(' ', '').split(',')[0],
          longitude: coordinates.replaceAll(' ', '').split(',')[1],
        },
        isPrivateAccess: isPrivateAccess,
        //TODO: add textField for timeZone
        timeZone: timeZone,
        operator: operatorUser.operator._id
          ? operatorUser.operator._id
          : operatorUser.operator,
      }
      addStation(station)
    }

    const addNewStationRef = useRef(addNewStation)

    useEffect(() => {
      addNewStationRef.current = addNewStation
    })

    const handleClose = () => {
      setStationName('')
      setStreetName('')
      setCity('')
      setCoordinates(initialCoordinates)
      setIsPrivateAccess(false)
      if (isPrivateAccessRef.current) isPrivateAccessRef.current.setValue(false)
      setCityError('')
      setCoordinatesError('')
      setStationNameError('')
      setStreetNameError('')
    }
    const customDialogContentStyle = {
      width: '63rem',
      height: '26rem',
    }

    return (
      <Fragment>
        <IFModal
          maxWidth={'65rem'}
          onDismiss={handleClose}
          title={t('AddStationModal.AddSite')}
          ref={ref}
          dialogContentStyle={customDialogContentStyle}
          style={{ borderRadius: 5 }}
        >
          <Fragment>
            <div className={Styles.bottomWrapper}>
              <div className={Styles.bottomContainer}>
                <div className={Styles.bottomItem}>
                  <div>
                    <IFText
                      className={Styles.textTitle}
                      style={{ color: Colors.text, marginTop: 0 }}
                    >
                      {t('AddStationModal.SiteName')}
                    </IFText>
                    <IFTextInput
                      style={{ color: Colors.text }}
                      className={Styles.textInput}
                      fontSize={16}
                      value={stationName}
                      onBlur={(e) => {
                        e.target.value.length === 0
                          ? setStationNameError(t('AddStationModal.Required'))
                          : setStationNameError('')
                      }}
                      onChange={(e) => {
                        setStationName(e.target.value)
                        if (stationNameError.length > 0) {
                          e.target.value.length === 0
                            ? setStationNameError(t('AddStationModal.Required'))
                            : setStationNameError('')
                        }
                      }}
                      maxWidth={'21rem'}
                      {...(stationNameError.length > 0
                        ? { errorText: stationNameError }
                        : {})}
                    />
                  </div>
                  <div>
                    <IFText
                      className={Styles.textTitle}
                      style={{ color: Colors.text, marginTop: 0 }}
                    >
                      {t('AddStationModal.StreetName')}
                    </IFText>
                    <IFTextInput
                      style={{ color: Colors.text }}
                      className={Styles.textInput}
                      fontSize={16}
                      value={streetName}
                      onChange={(e) => {
                        setStreetName(e.target.value)
                        if (streetNameError.length > 0) {
                          e.target.value.length === 0
                            ? setStreetNameError(t('AddStationModal.Required'))
                            : setStreetNameError('')
                        }
                      }}
                      onBlur={(e) => {
                        e.target.value.length === 0
                          ? setStreetNameError(t('AddStationModal.Required'))
                          : setStreetNameError('')
                      }}
                      maxWidth={'21rem'}
                      {...(streetNameError.length > 0
                        ? { errorText: streetNameError }
                        : {})}
                    />
                  </div>
                  <div>
                    <IFText
                      className={Styles.textTitle}
                      style={{ color: Colors.text }}
                    >
                      {t('AddStationModal.City')}
                    </IFText>
                    <div className={Styles.cityInput}>
                      <StyledFormControl onClick={(e) => e.stopPropagation()}>
                        <SelectPicker
                          size="sm"
                          preventOverflow={true}
                          menuStyle={{
                            color: Colors.text,
                            zIndex: 1500,
                          }}
                          appearance="subtle"
                          searchable={true}
                          cleanable={false}
                          onOpen={() => {
                            city.length === 0
                              ? setCityError(t('AddStationModal.Required'))
                              : setCityError('')
                          }}
                          onSelect={(value) => {
                            setCity(value)
                            value.length === 0
                              ? setCityError(t('AddStationModal.Required'))
                              : setCityError('')
                          }}
                          data={citiesOptions}
                          value={city}
                          className={Styles.selectPicker}
                        />
                      </StyledFormControl>
                      <div className={Styles.addCityIcon}>
                        <Icon
                          className={Styles.addCityButton}
                          sx={{ fontSize: 20, color: Colors.black }}
                          component={AddIcon}
                          onClick={() => addCityModalRef.current.show()}
                        />
                      </div>
                    </div>
                    <div
                      style={{ color: Colors.red }}
                      className={Styles.ErrorStyling}
                    >
                      {cityError.length > 0 ? (
                        <IFText style={{ fontSize: '0.75rem' }}>
                          {cityError}
                        </IFText>
                      ) : null}
                    </div>
                  </div>
                  <div>
                    <IFText
                      className={Styles.textTitle}
                      style={{ color: Colors.text }}
                    >
                      {t('AddStationModal.Coordinates')}
                    </IFText>
                    <IFTextInput
                      style={{ color: Colors.text }}
                      className={Styles.textInput}
                      value={coordinates}
                      fontSize={16}
                      onChange={(e) => {
                        setCoordinates(e.target.value)
                        if (coordinatesError.length > 0) {
                          e.target.value.length === 0
                            ? setCoordinatesError(t('AddStationModal.Required'))
                            : setCoordinatesError('')
                        }
                      }}
                      onBlur={(e) => {
                        e.target.value.length === 0
                          ? setCoordinatesError(t('AddStationModal.Required'))
                          : setCoordinatesError('')
                      }}
                      maxWidth={'21rem'}
                      {...(coordinatesError.length > 0
                        ? { errorText: coordinatesError }
                        : {})}
                    />
                  </div>
                  <div>
                    <IFText
                      className={Styles.textTitle}
                      style={{ color: Colors.text }}
                    >
                      {t('AddStationModal.Access')}
                    </IFText>
                    <IFToggle
                      ref={isPrivateAccessRef}
                      height={22}
                      fontSize={12}
                      checkedText={t('AddStationModal.Public')}
                      uncheckedText={t('AddStationModal.Private')}
                      readOnly={false}
                      defaultChecked={true}
                      onChange={(value) => {
                        setIsPrivateAccess(!value)
                      }}
                    />
                  </div>
                </div>
                <div style={{ flexGrow: 2.5, flexShrink: 0 }}>
                  <IFMap
                    style={{ height: '100%' }}
                    latitude={coordinates.replaceAll(' ', '').split(',')[0]}
                    longitude={coordinates.replaceAll(' ', '').split(',')[1]}
                  />
                </div>
              </div>
              <div
                className={Styles.actionsContainer}
                style={{ borderLeft: `1px solid ${Colors.DividerColor}` }}
              >
                <div className={Styles.buttonsContainer}>
                  <IFTooltipIconsLoading
                    onClick={() => {
                      addNewStationRef.current()
                    }}
                    tooltipPlacement="left"
                    title={t('AddStationModal.Add')}
                    isDead={
                      validator.isEmpty(stationName) ||
                      validator.isEmpty(streetName) ||
                      validator.isEmpty(city) ||
                      validator.isEmpty(coordinates) ||
                      !(
                        coordinates.replaceAll(' ', '').split(',')[0] &&
                        validator.isFloat(
                          coordinates.replaceAll(' ', '').split(',')[0],
                        ) &&
                        coordinates.replaceAll(' ', '').split(',')[1] &&
                        validator.isFloat(
                          coordinates.replaceAll(' ', '').split(',')[1],
                        )
                      )
                    }
                    isLoading={addStationRequestState === RequestState.LOADING}
                    Icon={IFsvg.Done}
                    FilledIcon={IFsvg.Done}
                    iconColor={Colors.primary}
                    size={26}
                    iconClassname={Styles.tooltipIcons}
                    animationDisabled={false}
                  />
                </div>
              </div>
            </div>
          </Fragment>
        </IFModal>
        <AddCityModal ref={addCityModalRef} />
      </Fragment>
    )
  },
)
AddStationModal.propTypes = {
  operatorUser: PropTypes.object,
  addStationRequestState: PropTypes.number,
  addStation: PropTypes.func,
}
function mapDispatchToProps(dispatch) {
  return {
    addStation: (station) => dispatch(StationActions.addStation(station)),
  }
}

const mapStateToProps = (state) => ({
  addStationRequestState: StationSelectors.getAddStationRequestState(state),
  operatorUser: AuthSelectors.getOperatorUser(state),
  operator: AuthSelectors.getOperator(state),
  cities: StationSelectors.getCities(state),
  stationsFilter: StationSelectors.getStationsFilter(state),
  addCityRequestState: StationSelectors.getAddCityRequestState(state),
})

export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(AddStationModal)
